import { useState, useEffect, useCallback, useRef } from "react";
import { staffQueue } from "../api";

/**
 * useQueuePoller
 * Polls /queue/my-queue/ every INTERVAL ms.
 * Returns { queue, loading, error, refresh }
 * queue shape:
 *   { station, serving, waiting, waiting_count, outcomes }
 */
const INTERVAL = 8000; // 8 seconds

export default function useQueuePoller() {
  const [queue,   setQueue]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);
  const timerRef              = useRef(null);
  const mountedRef            = useRef(true);

  const fetch = useCallback(async (showLoader = false) => {
    if (showLoader) setLoading(true);
    try {
      const { data } = await staffQueue.myQueue();
      if (mountedRef.current) {
        setQueue(data);
        setError(null);
      }
    } catch (err) {
      if (mountedRef.current) {
        setError(err.response?.data?.error || "Failed to load queue.");
      }
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    fetch(true);
    timerRef.current = setInterval(() => fetch(false), INTERVAL);
    return () => {
      mountedRef.current = false;
      clearInterval(timerRef.current);
    };
  }, [fetch]);

  return { queue, loading, error, refresh: () => fetch(false) };
}
